
























































import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import Vue from 'vue';

interface Background {
  image: string;
  name: string;
  author: string;
  link: string;
}

@Component
export default class PundPSettings extends Vue {
  public availableBackgrounds: Background[] = [
    {
      image: 'Battle.jpg',
      name: 'Battle between dark and light',
      author: 'Frostwindz',
      link:
        'https://www.deviantart.com/frostwindz/art/The-Battle-Between-Dark-and-Ligth-490629278',
    },
    {
      image: 'Battle2.jpg',
      name: 'Final Battle',
      author: 'JanPhilippEckert',
      link:
        'https://www.deviantart.com/janphilippeckert/art/Final-Battle-480835718',
    },
    {
      image: 'Battle3.jpg',
      name: 'Medieval battle',
      author: 'VitoSs',
      link: 'https://www.deviantart.com/vitoss/art/medieval-battle-411952501',
    },
    {
      image: 'Battle4.jpg',
      name: 'Army Speedpaint',
      author: 'Narcotic-Nightmares',
      link:
        'https://www.deviantart.com/narcotic-nightmares/art/Army-Speedpaint-403343100',
    },
    {
      image: 'Battle5.jpg',
      name: 'Battle between dark and light',
      author: 'Frostwindz',
      link:
        'https://www.deviantart.com/frostwindz/art/The-Battle-Between-Dark-and-Ligth-490629278',
    },
    {
      image: 'Battle6.jpg',
      name: 'Battle between dark and light',
      author: 'Frostwindz',
      link:
        'https://www.deviantart.com/frostwindz/art/The-Battle-Between-Dark-and-Ligth-490629278',
    },
  ];
  private open: boolean = false;
  private selectedBackground: string = '';
  private selectedOpacity: number = 0;
  private originalBackground: string = '';
  private originalOpacity: number = 60;
  private accountDetails = {
    name: null,
    email: null,
    saving: false,
  };

  constructor() {
    super();
  }

  public created(): void {
    this.selectedBackground = this.activeBackground;
    this.selectedOpacity = this.opacity;
    this.originalBackground = this.activeBackground;
    this.originalOpacity = this.opacity;
  }

  public createGroup(): void {
    this.$store.dispatch('createGroup', 'Neue Gruppe');
  }

  public saveAccountDetails() {
    this.accountDetails.saving = true;
    this.$store.dispatch('saveAccountDetails', this.accountDetails).then(() => {
      this.accountDetails.saving = false;
    });
  }

  public changeBackground(background: string) {
    this.selectedBackground = background;
  }

  public saveBackground() {
    const payload = {
      background: this.selectedBackground,
      opacity: this.selectedOpacity,
    };
    this.$store.dispatch('changeBackground', payload).then(() => {
      this.originalBackground = this.activeBackground;
      this.originalOpacity = this.opacity;
    });
  }

  public resetBackground() {
    this.selectedBackground = this.originalBackground;
    this.selectedOpacity = this.originalOpacity;
  }

  private getBackground(background: string) {
    return require('@/assets/css/' + background);
  }

  @Watch('selectedOpacity')
  @Watch('selectedBackground')
  private onOpacityChanged(newValue: number, oldValue: number) {
    const payload = {
      background: this.selectedBackground,
      opacity: this.selectedOpacity,
    };
    this.$store.commit('changeBackground', payload);
  }

  @Watch('isLoading')
  private onUserDataLoad(newValue: boolean, oldValue: boolean) {
    if (!newValue) {
      this.originalBackground = this.activeBackground;
      this.originalOpacity = this.opacity;
      this.selectedBackground = this.activeBackground;
      this.selectedOpacity = this.opacity;
      this.accountDetails.name = this.$store.getters.userData.name;
      this.accountDetails.email = this.$store.getters.getUser.email;
    }
  }

  get isLoading(): boolean {
    return this.$store.getters.userData === null;
  }

  get settings(): object {
    return this.$store.getters.settings;
  }

  get groups(): object[] {
    return this.$store.getters.groups;
  }

  get groupInvitations(): object[] {
    return this.$store.getters.groupInvitations;
  }

  get activeBackground(): string {
    return this.$store.getters.backgroundImage;
  }

  get opacity(): number {
    return this.$store.getters.backgroundOpacity;
  }

  get changedBackground(): boolean {
    return (
      this.selectedBackground !== this.originalBackground ||
      this.selectedOpacity !== this.originalOpacity
    );
  }
}
